import { render, staticRenderFns } from "./AuthFail.vue?vue&type=template&id=bcc1b62c&"
import script from "./AuthFail.vue?vue&type=script&lang=js&"
export * from "./AuthFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports